import { Injectable } from '@angular/core';
import { IKeyValuePair } from '../../modelau/key-value';
import { OpsiwnStatwsArchifo } from '../../modelau/system/opsiwn-statws-archifo';

@Injectable({
    providedIn: 'root'
})
export class HelpiwrService {

    constructor() { }

    // Wedi newid o data.eitemau i data - hyn yn gadael ni pasio unrhyw list fewn wedyn
    public felKeyValue(data: any, selector: string = 'disgrifiad', key: string = 'id'): IKeyValuePair[] {
        return data.map(eitem => ({ key: eitem[key], value: eitem[selector] }));
    }

    public felKeyValueTrwyddedau(data: any, selector: string = 'cod', key: string = 'id'): IKeyValuePair[] {
        return data.map(eitem => ({ key: eitem[key], value: eitem[selector] }));
    }

    public felOpsiwnStatwsArchifo(data: any, selector: string = 'disgrifiad', key: string = 'id') : OpsiwnStatwsArchifo[]{
        return data.map(eitem => ({key: eitem[key], value: eitem[selector], wediArchifo: eitem["wediArchifo"]}));
    }
}
